'use strict';
import React, { Component } from 'react';
import { Redirect } from 'react-router';
import { GenericErrorScreen } from 'com-gyf-webcore-userinterfacecomponents';
import Table from './Table.jsx';
import Headers from './Headers.jsx';

class ListadoProductos extends Component {

    constructor(props) {
        super(props);
        this.state = { data: {} }
    }

    componentDidMount() {
        this.props.getScreenData(this.props.routeState, this.props.currentScope);
    }

    componentWillUnmount() {
        this.props.resetState();
    }

    render() {
        let componentProduct = null;
        let functions = this.props.data.user_functions;

        const {
            data,
            redirect,
            clickCheckbox,
            orderColumn,
            selectAllCheckbox,
            routeToEditarProducto,
            routeToNuevoProducto,
            deleteProductos
        } = this.props;

        if (redirect.shouldRedirect)
            return <Redirect to={redirect.to} push />;

        if (!functions)
			return null;

        let consulta = functions.Consulta == true;

        if (!consulta)
		{
			const errorValues = {
                message: "Disculpe, no tiene permisos para acceder a esta pantalla.",
                linkMessage: "Volver a mi pagina de inicio"
            };

            return <GenericErrorScreen data={errorValues} />;
		}
            

        return (
            <div className="container-fluid">
                <Headers
                    data={data}
                    routeToNuevoProducto={routeToNuevoProducto}
                    deleteProductos={deleteProductos}
                />
                <br />
                <Table
                    data={data}
                    clickCheckbox={clickCheckbox}
                    orderColumn={orderColumn}
                    selectAllCheckbox={selectAllCheckbox}
                    routeToEditarProducto={routeToEditarProducto}
                />
            </div>
        );
    }
}

export default ListadoProductos;